<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <div class="l-page__header c-page__header">
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        {{ pageTitle }}
      </h2>
      <div class="c-page__header-btns">
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm"
        />
      </div>
    </div>
    <div class="l-page__item l-page--search__item">
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <el-form
          ref="filterParams"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="90px"
          label-suffix="："
          class="c-form c-condition__form"
        >
          <el-row class="c-form__row">
            <el-col
              v-if="!pendingMode"
              :span="6"
              class="c-form__col"
            >
              <el-form-item
                label="报告编号"
                prop="bgbh"
                class="c-form__item"
              >
                <el-input
                  v-model.trim="filterParams.bgbh"
                  clearable
                  placeholder="请输入报告编号"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="pendingMode ? 8 : 6"
              class="c-form__col"
            >
              <el-form-item
                label="项目名称"
                prop="xmmc"
                class="c-form__item"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  clearable
                  placeholder="请输入项目名称"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="pendingMode"
              :span="8"
              class="c-form__col"
            >
              <el-form-item
                label="委托单位"
                prop="wtdw"
                class="c-form__item"
              >
                <el-input
                  v-model.trim="filterParams.wtdw"
                  clearable
                  placeholder="请输入委托单位"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="!pendingMode"
              :span="6"
              class="c-form__col"
            >
              <el-form-item
                label="报告状态"
                prop="bgzt"
                class="c-form__item"
              >
                <el-select
                  v-model="filterParams.bgzt"
                  clearable
                  placeholder="全部状态"
                >
                  <el-option
                    label="已生成待盖章"
                    value="YSC"
                  />
                  <el-option
                    label="已上传盖章签字报告"
                    value="YGZ"
                  />
                  <el-option
                    label="历史版本"
                    value="LS"
                  />
                  <el-option
                    label="已作废"
                    value="YZF"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-if="!pendingMode"
              :span="6"
              class="c-form__col"
            >
              <el-form-item
                label="综合结论"
                prop="zhjl"
                class="c-form__item"
              >
                <el-select
                  v-model="filterParams.zhjl"
                  clearable
                  placeholder="全部结论"
                >
                  <el-option
                    label="合格"
                    value="HG"
                  />
                  <el-option
                    label="不合格"
                    value="BHG"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
    <div class="l-page__body l-page--search__body">
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane label="查询结果">
          <k-table
            height="100%"
            :table-column="tableColumns"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template #xmmc="scope">
              <el-link
                type="primary"
                @click="openProject(scope.row)"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>
            <template #bgbh="scope">
              <el-link
                v-if="scope.row.bgbh && reportFileId(scope.row)"
                type="primary"
                @click="downloadReport(scope.row)"
              >
                {{ scope.row.bgbh }}
              </el-link>
              <span v-else>{{ scope.row.bgbh || '-' }}</span>
            </template>
            <template #jcjl="scope">
              <span :class="scope.row.jcjl === 'HG' ? 'u-text-success' : (scope.row.jcjl === 'BHG' ? 'u-text-danger' : '')">
                {{ conclusionText(scope.row.jcjl) }}
              </span>
            </template>
            <el-table-column
              v-if="pendingMode && isProjectManager"
              label="操作"
              width="190"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <k-button
                  v-if="scope.row.xmzt === 'DSC'"
                  btn-text="预览"
                  :auth-type="false"
                  type="primary"
                  plain
                  @click="previewReport(scope.row)"
                />
                <k-button
                  v-if="scope.row.xmzt === 'DSC'"
                  btn-text="生成正式报告"
                  :auth-type="false"
                  type="success"
                  plain
                  @click="generateReport(scope.row)"
                />
              </template>
            </el-table-column>
            <el-table-column
              v-if="!pendingMode && isProjectManager"
              label="操作"
              width="150"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <k-button
                  v-if="canUploadSealedReport(scope.row)"
                  btn-text="上传签字报告"
                  :auth-type="false"
                  type="primary"
                  plain
                  icon="kestrel-icon ki-upload"
                  @click="openUploadDialog(scope.row)"
                />
                <span v-else>-</span>
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      title="上传签字盖章报告"
      :visible.sync="uploadDialog.visible"
      width="520px"
      append-to-body
      :close-on-click-modal="false"
      @closed="resetUploadDialog"
    >
      <el-form label-width="90px">
        <el-form-item label="项目名称">
          <span>{{ uploadDialog.row ? uploadDialog.row.xmmc : '-' }}</span>
        </el-form-item>
        <el-form-item label="报告编号">
          <span>{{ uploadDialog.row ? uploadDialog.row.bgbh : '-' }}</span>
        </el-form-item>
        <el-form-item
          label="报告文件"
          required
        >
          <file-serve-upload
            ref="sealedReportUpload"
            v-model="uploadDialog.fileId"
            :data="uploadFd"
            :format="['pdf', 'PDF']"
            accept="application/pdf,.pdf"
            :max-size="30 * 1024"
            show-file-list
          >
            <k-button
              btn-text="选择 PDF"
              :auth-type="false"
              type="primary"
              plain
              icon="kestrel-icon ki-cloud-upload"
            />
          </file-serve-upload>
          <div class="u-text-warning">
            仅支持 PDF，文件大小不超过 30 MB
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="uploadDialog.visible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="uploadDialog.submitting"
          :disabled="!uploadDialog.fileId"
          @click="submitSealedReport"
        >
          确认上传
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { reportService } from './report.service.js';

export default {
  name: 'JxxfJcReportList',
  data () {
    return {
      loading: false,
      isProjectManager: false,
      uploadDialog: { visible: false, submitting: false, row: null, fileId: '' },
      uploadFd: { meta: [{ key: 'type', value: 'jxxfjcqzbg' }] },
      filterParams: { bgbh: null, xmmc: null, wtdw: null, bgzt: null, zhjl: null, dateRange: [] },
      trueFilterParams: {},
      page: { rows: [], total: 0, pageSize: 15, pageNo: 0 }
    };
  },
  computed: {
    pendingMode () { return this.$route.name === 'jxxfJcPendingReportIndex'; },
    pageTitle () { return this.pendingMode ? '待生成检测报告' : '检测报告管理'; },
    tableColumns () {
      const index = { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' };
      if (this.pendingMode) {
        return [index,
          { key: 'xmmc', slotName: 'xmmc', label: '项目名称', align: 'left', minWidth: '200', type: 'text' },
          { key: 'wtdw', label: '委托单位', align: 'left', minWidth: '180', type: 'text' },
          { key: 'jcjl', slotName: 'jcjl', label: '检测结论', align: 'center', width: '100', type: 'text' },
          { key: 'createTime', label: '创建时间', align: 'center', width: '150', type: 'dateTime' }
        ];
      }
      return [index,
        { key: 'bgbh', slotName: 'bgbh', label: '报告编号', align: 'left', minWidth: '190', type: 'text' },
        { key: 'bgbbh', label: '报告版本', align: 'center', width: '100', type: 'text' },
        { key: 'xmmc', slotName: 'xmmc', label: '项目名称', align: 'left', minWidth: '200', type: 'text' },
        { key: 'wtdw', label: '委托单位', align: 'left', minWidth: '180', type: 'text' },
        { key: 'bgrq', label: '报告日期', align: 'center', width: '110', type: 'date' },
        { key: 'zhjlMc', label: '检测结论', align: 'center', width: '100', type: 'text' },
        { key: 'bgztMc', label: '报告状态', align: 'center', width: '150', type: 'text' },
        { key: 'scsj', label: '生成时间', align: 'center', width: '150', type: 'dateTime' }
      ];
    }
  },
  methods: {
    resetPage () {
      this.filterParams = { bgbh: null, xmmc: null, wtdw: null, bgzt: null, zhjl: null, dateRange: [] };
      this.page = { rows: [], total: 0, pageSize: 15, pageNo: 0 };
      this.refreshSearch();
    },
    refreshSearch () {
      const params = JSON.parse(JSON.stringify(this.filterParams));
      params.rqq = params.dateRange && params.dateRange[0];
      params.rqz = params.dateRange && params.dateRange[1];
      delete params.dateRange;
      this.trueFilterParams = params;
      this.search(1);
    },
    search (pageNo = 1) {
      const params = Object.assign({}, this.trueFilterParams, { pageNo, pageSize: this.page.pageSize });
      this.loading = true;
      const request = this.pendingMode ? reportService.pendingPage(params) : reportService.page(params);
      request.then(rsp => { this.page = Object.assign({}, this.page, rsp.data); })
        .finally(() => { this.loading = false; });
    },
    handleSizeChange (pageSize) { this.page.pageSize = pageSize; this.search(1); },
    resetForm () { this.$refs.filterParams.resetFields(); this.refreshSearch(); },
    openProject (row) { this.openNavTab({ name: 'jxxfJcProjectDetail', params: { xmId: row.xmId } }); },
    conclusionText (value) {
      if (value === 'HG' || value === 'Y') return '合格';
      if (value === 'BHG' || value === 'N') return '不合格';
      return '/';
    },
    reportFileId (row) { return row.gzqzbgfjid || row.ysbgfjid; },
    canUploadSealedReport (row) {
      return row.bgzt === 'YSC' && !!row.ysbgfjid && !row.gzqzbgfjid;
    },
    openUploadDialog (row) {
      this.uploadDialog = { visible: true, submitting: false, row, fileId: '' };
    },
    resetUploadDialog () {
      if (this.$refs.sealedReportUpload) this.$refs.sealedReportUpload.clearFiles();
      this.uploadDialog = { visible: false, submitting: false, row: null, fileId: '' };
    },
    submitSealedReport () {
      if (!this.uploadDialog.fileId || !this.uploadDialog.row) {
        this.$message.warning('请先选择签字盖章后的 PDF 报告');
        return;
      }
      this.uploadDialog.submitting = true;
      reportService.uploadSealedReport(this.uploadDialog.row.xmId, this.uploadDialog.fileId)
        .then(rsp => {
          const result = rsp.data && rsp.data.data;
          this.$message.success((result && result.message) || '签字盖章报告上传成功');
          this.uploadDialog.visible = false;
          this.search(this.page.pageNo || 1);
        })
        .catch(() => {})
        .finally(() => { this.uploadDialog.submitting = false; });
    },
    downloadReport (row) {
      const fileId = this.reportFileId(row);
      this.$axios.get(`${this.$config.fileApi.initDownload}/${fileId}`).then(rsp => {
        const path = rsp.data && rsp.data.data;
        if (!path) throw new Error('报告文件路径为空');
        return this.$axios.get(`${this.$config.fileApi.download}/${path}`, { responseType: 'blob' });
      }).then(res => this.$HMUtil.downloadStreamFile(res.data, `${row.bgbh || '检测报告'}.pdf`))
        .catch(() => this.$message.error('报告下载失败'));
    },
    previewReport (row) {
      this.loading = true;
      reportService.preview(row.xmId)
        .then(rsp => {
          const result = rsp.data && rsp.data.data;
          if (!result || !result.fileId) {
            this.$message.error('预览报告文件生成失败');
            return;
          }
          this.$message.success(result.message || '预览报告生成成功');
          this.$utils.previewPdf({ currentTarget: { __vue__: this } }, result.fileId, row);
        })
        .catch(() => this.$message.error('预览报告生成失败'))
        .finally(() => { this.loading = false; });
    },
    generateReport (row) {
      this.$confirm(`确认生成项目“${row.xmmc}”的正式检测报告？`, '提示', { type: 'warning' })
        .then(() => {
          this.loading = true;
          return reportService.generate(row.xmId)
            .then(rsp => {
              const result = rsp.data && rsp.data.data;
              this.$message.success((result && result.message) || '正式报告生成成功');
              this.search(this.page.pageNo || 1);
            })
            .catch(() => this.$message.error('正式报告生成失败'))
            .finally(() => { this.loading = false; });
        }).catch(() => {});
    }
  },
  watch: {
    '$route.name' () { this.resetPage(); }
  },
  created () {
    this.isProjectManager = ((this.$HMStoreService.getUserinfo() || {}).roles || []).includes('JX-XMGLY');
    this.refreshSearch();
  }
};
</script>
